import {Pipe, PipeTransform} from '@angular/core';
import * as _ from 'lodash';
@Pipe({
  name: 'orderBy',
  pure: false
})
export class OrderByPipe implements PipeTransform {

  transform(array: Array<any>, args?: any): any {
    return _.sortBy(array, args);
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/pipe/order-by.pipe.ts